import { useTranslation } from "react-i18next";
import styles from "./ConfirmationModal.module.css";

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm?: () => void;
  title: string;
  message: string;
  icon?: "success" | "info" | "danger";
  variant?: "primary" | "danger";
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  variant = "primary",
}) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal} role="dialog" aria-modal="true">
        <div className={styles.body}>
          <h3 className={styles.title}>{title}</h3>
          <p className={styles.message}>{message}</p>
        </div>

        <div className={styles.footer}>
          {onConfirm ? (
            <>
              <button type="button" onClick={onClose} className={styles.cancelBtn}>
                {t("common.cancel")}
              </button>
              <button
                type="button"
                onClick={onConfirm}
                className={variant === "danger" ? styles.confirmDanger : styles.confirmPrimary}
              >
                {t("common.confirm")}
              </button>
            </>
          ) : (
            <button type="button" onClick={onClose} className={styles.okBtn}>
              {t("common.ok")}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
